import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

const StripeReturn: React.FC = () => {
  const [searchParams] = useSearchParams();
  const status = searchParams.get('stripe');

  useEffect(() => {
    if (window.opener) {
      window.opener.postMessage(
        { type: 'stripe_connect', status },
        window.location.origin
      );
      window.close();
    }
  }, [status]);

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center">
      <div className="text-center">
        {status === 'connected' ? (
          <>
            <div className="w-12 h-12 rounded-full bg-green-900/40 flex items-center justify-center mx-auto mb-3">
              <svg className="w-6 h-6 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-sm font-medium text-gray-200">Stripe connected!</p>
            <p className="text-xs text-gray-500 mt-1">This window will close automatically.</p>
          </>
        ) : (
          <>
            <p className="text-sm font-medium text-gray-200">Setup link expired</p>
            <p className="text-xs text-gray-500 mt-1">Close this window and try connecting again.</p>
          </>
        )}
      </div>
    </div>
  );
};

export default StripeReturn;
